import { InteractionType, EventSource, MixpanelEvent, ComponentType } from '../MixPanelTypes';

export type TenantConfigurationEvents = 'DATE_AND_TIME_SAVE';

export const tenantConfiguration: Record<TenantConfigurationEvents, MixpanelEvent> = {
  DATE_AND_TIME_SAVE: {
    eventDescription: 'Tenant Date and Time Save',
    eventKey: 'tenant-date-and-time-save',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DIALOG_CONFIRM_BUTTON
  }
} as const;
